export default __webpack_public_path__ + "static/img-02-1db505935e2d5af121db193723496f38.png";